/**
 *
 * ButtonCardIcon
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// import useDeviceDetect from 'utils/useDeviceDetect';

// antd component
import { Button } from 'antd';

// assets
import CustomIcons from 'components/CustomIcons';


function ButtonCardIcon({
  icon,
  title,
  action,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('action-btn card-button', className);
  //const { isMobile } = useDeviceDetect();

  return title && (
    <Button
      className={childClassNames}
      icon={icon && <CustomIcons className="card-button__icon" type={icon} />}
      onClick={action !== undefined && action}
      {...rest}
    >
      <span className="card-button__title">{title}</span>
    </Button>
  );
}

ButtonCardIcon.defaultProps = {};
ButtonCardIcon.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  action: PropTypes.func
};

export default memo(ButtonCardIcon);
